import React, { FC } from 'react'
import {
  BlueDotIcon,
  CircleWithHtmlTagsIcon,
  CircleWithSheetsIcon,
  ColorFillInCircleIcon,
  HeaderDashedCircleIcon,
  MarkdownInDiamondIcon,
  RichTextInCircleIcon,
  SafeInDiamondIcon,
  SecurityInDiamondIcon,
  TasksInCircleIcon,
  TextboxPasswordPinkInCircleIcon,
  TextParagraphInCircleIcon,
} from '../../assets/icons'
import styled from 'styled-components'
import { ScreenBreakpointSize } from '../../utils/enums'
import { getScreenBreakpointSize } from '../../utils/getScreenBreakpointSize'

const HeaderDashedCircleIconStyled = styled.img`
  position: absolute;

  &[data-name='icon-1'] {
    left: 25%;
    top: 1%;
  }
  &[data-name='icon-2'] {
    left: 58%;
    top: 3%;
  }
  &[data-name='icon-3'] {
    left: 76%;
    top: 25%;
  }
  &[data-name='icon-4'] {
    left: 31%;
    top: 35%;
  }
  &[data-name='icon-5'] {
    top: 81%;
    left: 24%;
  }
  &[data-name='icon-6'] {
    left: 73%;
    top: 83%;
  }

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    &[data-name='icon-1'] {
      left: -5%;
      top: 4%;
    }
    &[data-name='icon-2'] {
      left: 85%;
      top: 1%;
    }
    &[data-name='icon-3'] {
      left: -5%;
      top: 31%;
    }
    &[data-name='icon-4'] {
      left: 87%;
      top: 31%;
    }
    &[data-name='icon-5'] {
      display: none;
    }
    &[data-name='icon-6'] {
      display: none;
    }
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    &[data-name='icon-1'] {
      left: 10%;
      top: 4%;
    }
    &[data-name='icon-2'] {
      left: 63%;
      top: 1%;
    }
    &[data-name='icon-3'] {
      left: 21%;
      top: 36%;
    }
    &[data-name='icon-4'] {
      left: 87%;
      top: 31%;
    }
    &[data-name='icon-5'] {
      left: 14%;
      top: 88%;
    }
    &[data-name='icon-6'] {
      left: 84%;
      top: 89%;
    }
  }
`
const BlueDotIconStyled = styled.img`
  position: absolute;

  &[data-name='icon-1'] {
    left: 28%;
    top: 2%;
  }
  &[data-name='icon-2'] {
    top: 11%;
    left: 63%;
  }
  &[data-name='icon-3'] {
    left: 75%;
    top: 32%;
  }
  &[data-name='icon-4'] {
    top: 41%;
    left: 34%;
  }
  &[data-name='icon-5'] {
    left: 22%;
    top: 79%;
  }
  &[data-name='icon-6'] {
    left: 76%;
    top: 81%;
  }

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    &[data-name='icon-1'] {
      left: 15%;
      top: 6%;
    }
    &[data-name='icon-2'] {
      top: 11%;
      left: 63%;
    }
    &[data-name='icon-3'] {
      left: 8%;
      top: 35%;
    }
    &[data-name='icon-4'] {
      top: 38%;
      left: 80%;
    }
    &[data-name='icon-5'] {
      display: none;
    }
    &[data-name='icon-6'] {
      display: none;
    }
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    &[data-name='icon-1'] {
      left: 17%;
      top: 6%;
    }
    &[data-name='icon-2'] {
      top: 6%;
      left: 70%;
    }
    &[data-name='icon-3'] {
      left: 27%;
      top: 41%;
    }
    &[data-name='icon-4'] {
      left: 82%;
      top: 36%;
    }
    &[data-name='icon-5'] {
      left: 11%;
      top: 85%;
    }
    &[data-name='icon-6'] {
      left: 92%;
      top: 87%;
    }
  }
`
const MarkdownInDiamondIconStyled = styled.img`
  position: absolute;
  left: 45%;
  top: 0;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: 36%;
    top: -4%;
  }
`
const SafeInDiamondIconStyled = styled.img`
  position: absolute;
  left: 78%;
  top: 3%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: 58%;
    top: 7%;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 83%;
    top: 1%;
  }
`
const CircleWithSheetsIconStyled = styled.img`
  position: absolute;
  left: 22%;
  top: 17%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: 5%;
    top: 20%;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 7%;
    top: 22%;
  }
`
const TextParagraphInCircleIconStyled = styled.img`
  position: absolute;
  left: 34%;
  top: 17%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: 24%;
    top: 9%;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 27%;
    top: 20%;
  }
`
const TextboxPasswordPinkInCircleIconStyled = styled.img`
  position: absolute;
  left: 65%;
  top: 16%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: 83%;
    top: 18%;
  }
`
const TasksInCircleIconStyled = styled.img`
  position: absolute;
  left: 20%;
  top: 43%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: -7%;
    top: 42%;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 6%;
    top: 43%;
  }
`
const RichTextInCircleIconStyled = styled.img`
  position: absolute;
  left: 68%;
  top: 34%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    left: auto;
    right: 0;
    top: 40%;
  }
`
const CircleWithHtmlTagsIconStyled = styled.img`
  position: absolute;
  left: 77%;
  top: 48%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    display: none;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 88%;
    top: 48%;
  }
`
const ColorFillInCircleIconStyled = styled.img`
  position: absolute;
  left: 29%;
  top: 60%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    display: none;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 16%;
    top: 60%;
  }
`
const SecurityInDiamondIconStyled = styled.img`
  position: absolute;
  left: 70%;
  top: 62%;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    display: none;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge, -1)}) {
    left: 78%;
    top: 60%;
  }
`

const IconsContainer: FC = () => {
  return (
    <>
      <HeaderDashedCircleIconStyled
        data-name="icon-1"
        alt="Dashed Circle Icon"
        aria-hidden="true"
        src={HeaderDashedCircleIcon}
      />
      <BlueDotIconStyled data-name="icon-1" alt="Blue Dot Icon" aria-hidden="true" src={BlueDotIcon} />
      <MarkdownInDiamondIconStyled alt="Markdown In Diamond Icon" aria-hidden="true" src={MarkdownInDiamondIcon} />
      <HeaderDashedCircleIconStyled
        data-name="icon-2"
        alt="Dashed Circle Icon"
        aria-hidden="true"
        src={HeaderDashedCircleIcon}
      />
      <BlueDotIconStyled data-name="icon-2" alt="Blue Dot Icon" aria-hidden="true" src={BlueDotIcon} />
      <SafeInDiamondIconStyled alt="Safe In Diamond Icon" aria-hidden="true" src={SafeInDiamondIcon} />
      <CircleWithSheetsIconStyled alt="Circle With Sheets Icon" aria-hidden="true" src={CircleWithSheetsIcon} />
      <TextParagraphInCircleIconStyled
        alt="Text Paragraph In Circle Icon"
        aria-hidden="true"
        src={TextParagraphInCircleIcon}
      />
      <TextboxPasswordPinkInCircleIconStyled
        alt="Textbox Password Pink In Circle Icon"
        aria-hidden="true"
        src={TextboxPasswordPinkInCircleIcon}
      />
      <HeaderDashedCircleIconStyled
        data-name="icon-3"
        alt="Dashed Circle Icon"
        aria-hidden="true"
        src={HeaderDashedCircleIcon}
      />
      <BlueDotIconStyled data-name="icon-3" alt="Blue Dot Icon" aria-hidden="true" src={BlueDotIcon} />
      <TasksInCircleIconStyled alt="Tasks In Circle Icon" aria-hidden="true" src={TasksInCircleIcon} />
      <HeaderDashedCircleIconStyled
        data-name="icon-4"
        alt="Dashed Circle Icon"
        aria-hidden="true"
        src={HeaderDashedCircleIcon}
      />
      <BlueDotIconStyled data-name="icon-4" alt="Blue Dot Icon" aria-hidden="true" src={BlueDotIcon} />
      <RichTextInCircleIconStyled alt="Rich Text In Circle Icon" aria-hidden="true" src={RichTextInCircleIcon} />
      <CircleWithHtmlTagsIconStyled alt="Circle With HTML Tags Icon" aria-hidden="true" src={CircleWithHtmlTagsIcon} />
      <ColorFillInCircleIconStyled alt="Color Fill In Circle Icon" aria-hidden="true" src={ColorFillInCircleIcon} />
      <SecurityInDiamondIconStyled alt="Security In Diamond Icon" aria-hidden="true" src={SecurityInDiamondIcon} />
      <HeaderDashedCircleIconStyled
        data-name="icon-5"
        alt="Dashed Circle Icon"
        aria-hidden="true"
        src={HeaderDashedCircleIcon}
      />
      <BlueDotIconStyled data-name="icon-5" alt="Blue Dot Icon" aria-hidden="true" src={BlueDotIcon} />
      <HeaderDashedCircleIconStyled
        data-name="icon-6"
        alt="Dashed Circle Icon"
        aria-hidden="true"
        src={HeaderDashedCircleIcon}
      />
      <BlueDotIconStyled data-name="icon-6" alt="Blue Dot Icon" aria-hidden="true" src={BlueDotIcon} />
    </>
  )
}

export default IconsContainer
